import React, { useState, useEffect, useRef } from "react";
import api from "../../services/api";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import { AiOutlinePlus } from "react-icons/ai";
import { toast } from "react-toastify";
import { toastProps } from "../../utils/toastProps.js";
import { AddButton } from "./styles";

function Busca(props) {
  const autoCompleteRef = useRef(null);
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState(props.single ? null : []);
  const [response, setResponse] = useState(props.listOld || (props.single ? null : []));
  const isInitialMount = useRef(true);

  // Estados para paginação
  const [currentPage, setCurrentPage] = useState(1);
  const [hasNextPage, setHasNextPage] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);

  const loadOldChoices = () => {
    let arrayQuery = [];
    arrayQuery.push(query);
    if (props.listOld) {
      if (Array.isArray(props.listOld)) {
        arrayQuery = arrayQuery.concat(props.listOld);
      } else {
        arrayQuery.push(props.listOld);
      }
    }

    arrayQuery = arrayQuery.map((item) =>
      (!item || item.nome === undefined) ? item : item.nome
    );

    return arrayQuery;
  };

  useEffect(() => {
    if (props.listOld) {
      if (props.single) {
        // Encontra o valor na listaOld caso seja array, ou pega o objeto
        const singleValue = Array.isArray(props.listOld) ? props.listOld[0] : props.listOld;
        const currentValue = Array.isArray(value) ? value[0] : value;
        
        // Só atualiza se for diferente para evitar loops e resets
        if (JSON.stringify(singleValue) !== JSON.stringify(currentValue)) {
          setValue(singleValue || null);
          if (singleValue?.nome) {
            setQuery(singleValue.nome);
            if (options.length === 0) {
              setOptions([singleValue]);
            }
          }
        }
      } else {
        // Só atualiza se a lista mudou de fato
        if (JSON.stringify(props.listOld) !== JSON.stringify(value)) {
          setValue(props.listOld);
          if (options.length === 0 && Array.isArray(props.listOld) && props.listOld.length > 0) {
            setOptions(props.listOld);
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.listOld, props.single]);

  // Função para carregar dados com paginação
  const loadData = async (page = 1, isLoadMore = false) => {
    if (isLoadMore) {
      setLoadingMore(true);
    } else {
      setLoading(true);
    }

    try {
      let arrayQuery = loadOldChoices();
      const responseResults = await api.get(
        `${props.url}?find=${arrayQuery[0]}&ordering=nome&page=${page}`
      );

      console.log("request:", `${props.url}?find=${arrayQuery[0]}&ordering=nome&page=${page}`);
      console.log("responseResults", responseResults);

      const newResults = responseResults.data?.results || [];

      // Verificar se há próxima página
      setHasNextPage(!!responseResults.data?.next);

      if (isLoadMore) {
        // Adicionar novos resultados aos existentes
        setOptions(prevOptions => [...prevOptions, ...newResults]);
      } else {
        // Substituir resultados (nova busca)
        setOptions(newResults);
        setCurrentPage(1);
      }

    } catch (error) {
      console.error("Erro ao carregar dados:", error);
      toast.error("Erro ao carregar dados", toastProps);
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  };

  // Carregar próxima página
  const loadNextPage = async () => {
    if (!hasNextPage || loadingMore) return;

    const nextPage = currentPage + 1;
    setCurrentPage(nextPage);
    await loadData(nextPage, true);
  };

  useEffect(() => {
    // Implementação de debounce para evitar excesso de requisições e bugs de UI
    const handler = setTimeout(() => {
      // Reset para primeira página quando query muda
      setCurrentPage(1);
      setHasNextPage(true);
      loadData(1, false);
    }, 500); // 500ms de atraso

    return () => {
      clearTimeout(handler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  useEffect(() => {
    // Evita disparar o onChange na montagem inicial para não limpar o estado do pai
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    props.onChange(response);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response]);

  const changeQuery = (event, newInputValue) => {
    if (event) event.preventDefault();
    setQuery(newInputValue);
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post(`${props.url}`, { nome: query });
      const response = await api.get(`${props.url}?find=${query}`);
      setOptions(
        Object.keys(response.data.results).map(
          (key) => response.data.results[key]
        )
      );
      toast.success(props.addSuccessMessage || "Novo item adicionado com sucesso", toastProps);
    } catch (error) {
      console.log(error);
      toast.error(props.addErrorMessage || "Erro ao adicionar item", toastProps);
    }
    setLoading(false);
  };

  // Detectar scroll no final da lista
  const handleScroll = (event) => {
    const { target } = event;
    const { scrollTop, clientHeight, scrollHeight } = target;

    // Se chegou ao final da lista (com margem de 10px)
    if (scrollHeight - scrollTop <= clientHeight + 10) {
      if (hasNextPage && !loadingMore) {
        loadNextPage();
      }
    }
  };

  const showAddButton = props.addAction && options.length === 0 && !loading && !loadingMore && query !== "";

  return (
    <div>
      <div style={props.single ? { display: 'flex', alignItems: 'flex-start', gap: '8px' } : {}}>
        <Autocomplete
          ref={autoCompleteRef}
          value={value}
          multiple={!props.single}
          autoHighlight={false}
          autoSelect={false}
          style={{ width: props.single && showAddButton ? 270 : 300 }}
          open={open}
          loadingText="Carregando..."
          noOptionsText={hasNextPage ? "Carregando mais..." : "Nenhum resultado encontrado"}
          disableCloseOnSelect={!props.single}
          clearOnBlur={false}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          onChange={(event, values) => {
            console.log(values);
            if (props.single) {
              // Modo seleção única
              setResponse(values ? [values] : []);
              setValue(values);
              if (values) {
                setQuery(values.nome || "");
              }
            } else {
              // Modo múltiplo (padrão)
              setResponse(values);
              setValue(values);
            }
          }}
          inputValue={query}
          onInputChange={(event, newInputValue) => {
            changeQuery(event, newInputValue);
          }}
          getOptionLabel={(option) => option?.nome || ""}
          getOptionSelected={(option, value) => {
            if (option.id && value.id) return option.id === value.id;
            return option.nome === value.nome;
          }}
          options={options}
          loading={loading}
          // Adicionar evento de scroll
          ListboxProps={{
            onScroll: handleScroll,
            style: { maxHeight: 200 } // Altura máxima para ativar scroll
          }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label=""
                  onKeyDown={(e) => {
                    // Prevenir que o "Enter" no campo de busca submeta o formulário pai acidentalmente
                    if (e.key === "Enter") {
                      // Se o dropdown não estiver aberto, previne a propagação
                      if (!open) {
                        e.stopPropagation();
                      }
                      // Note que se o dropdown estiver aberto, o Autocomplete já lida com o Enter para seleção
                    }
                  }}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loading || loadingMore ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
          // Renderizar opção com indicador de carregamento no final
          renderOption={(option, { selected }) => (
            <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
              <span style={{ flex: 1 }}>{option.nome}</span>
              {selected && <span>✓</span>}
            </div>
          )}
        />

        {props.addAction && !props.single && (
          <div>
            {options.length === 0 && !loading && !loadingMore && query !== "" && (
              <AddButton onClick={handleAdd}>
                <AiOutlinePlus color="#3f51b5" />
              </AddButton>
            )}
          </div>
        )}

        {props.single && showAddButton && (
          <button
            onClick={handleAdd}
            style={{
              background: 'transparent',
              border: 'none',
              padding: '6px 10px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: '4px',
            }}
            title="Adicionar novo"
          >
            <AiOutlinePlus color="#3f51b5" size={16} />
          </button>
        )}
      </div>

      {/* Indicador de carregamento mais itens */}
      {loadingMore && (
        <div style={{ textAlign: 'center', padding: '10px', fontSize: '12px', color: '#666', width: '300px' }}>
          Carregando mais itens...
        </div>
      )}
    </div>
  );
}

export default Busca;